module.exports = "/_next/static/resources/box-75333a71abc335b716e5d57015e8653e.jpg";